<!-- <app-menu></app-menu> -->
<po-page-default>
  <app-welcome></app-welcome>
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 selling-products">
    <span class="po-font-text po-clickable back-page" (click)="backHome()">Voltar</span>
    <po-widget>
      <span class="po-font-text-bold">Total de vendas</span>
      <po-table [p-items]="tableItens"></po-table>
      <div class="selling-products-container">
        <div class="po-xl-8 po-lg-8 po-md-8 po-sm-8 po-font-text-bold po-text-right selling-products-total">
          Total
        </div>
        <div class="po-xl-4 po-lg-4 po-md-4 po-sm-4 po-font-text-bold selling-products-value">
          <span>R$ {{ totalSales }}</span>
        </div>
      </div>
    </po-widget>
  </div>
</po-page-default>
